import { Box, Button, Card, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, InputLabel, MenuItem, Select, Tab, Tabs, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import { UIConfigurationContext } from "../../common/contexts/ui-configurationContext";
import { FormType } from "../../common/ui-form";
import { ISchoolModel } from "../models/ISchoolModel";

import { FacilitatorSchoolControlState } from "./facilitatorSchoolModel";
import { OlympiadExamConstants, OlympiadExamData } from "../../common/data/olympiadExams";
import { FoundationProgramConstants, FoundationProgramData } from "../../common/data/foundationPrograms";
import { IFoundationProgram, IProgramClass } from "../../common/models/foundationProgram";
import { ClassListConstants } from "../../common/data/classList";
import FacilitatorSchoolService from "./facilitatorSchoolService";
import { toast } from "react-toastify";
import { VideoLessionPrograms } from "../../common/data/videoLessionPrograms";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export const SchoolFieldSet: FunctionComponent<
    FormType<ISchoolModel> & { pageTitle?: string; pageSubtitle?: string }
> = ({
    values,
    handleBlur,
    handleChange,
    setFieldValue,
    errors,
    isValid,
    dirty,
    getValidationSchema,
    getControlState,
    isRequired,
    pageTitle,
    pageSubtitle,
    ...props
}) => {
        const navigate = useNavigate();
        const uiConfigData = React.useContext(UIConfigurationContext);
        const controlState: FacilitatorSchoolControlState = getControlState(values);
        const validationSchema = getValidationSchema(values);
        const [tabValue, setTabValue] = React.useState(0);
        const [saving, setSaving] = React.useState(false);

        const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
            setTabValue(newValue);
        };
        const CreateSchool = (createSchoolModel: ISchoolModel) => {
            setSaving(true);
            FacilitatorSchoolService.Create(createSchoolModel).then(() => {
                toast.success('School Created Successfully');
                navigate('/Schools/list');
            }).catch(() => {
                toast.error('Error in School Creation');
            }).finally(() => {
                setSaving(false);
            });
        }
        const UpdateSchool = (updateSchoolModel: ISchoolModel) => {
            setSaving(true);
            FacilitatorSchoolService.Update(updateSchoolModel).then(() => {
                toast.success('School Updated Successfully');
                navigate('/Schools/list');
            }).catch(() => {
                toast.error('Error in School Updating');
            }).finally(() => {
                setSaving(false);
            });
        }
        const handleSaveClick = () => {
            if (values.userId === 0)
                CreateSchool(values);
            else
                UpdateSchool(values);
        }
        const handleCancelClick = () => {
            navigate('/Schools/list');
        }
        const getOlympiadExam = (examId: number) => {
            return OlympiadExamConstants.find(i => i.examId == examId);
        }
        const handleOlympiadExamChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const isChecked = event.target.checked;
            // const name = event.target.name;
            const value = event.target.value;
            let data = values.olympiadExams;
            if (isChecked) {
                const selectedData = getOlympiadExam(parseInt(value));
                if (selectedData != undefined)
                    data.push(selectedData);
            } else {
                data = data.filter(i => i.examId !== parseInt(value));
            }
            setFieldValue('olympiadExams', data);

        }
        const handleAbhyasaBharathiAccessChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const isChecked = event.target.checked;
            setFieldValue('abhyasaBharathiMagazineAccess', isChecked);
        }
        const handleVideoLessionFilesAccessChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const isChecked = event.target.checked;
            setFieldValue('videoLessionFilesAccess', isChecked);
        }
        const isOlympiadExamSelected = (examId: number): boolean => {
            return (values.olympiadExams.find(i => i.examId === examId) !== undefined);
        }
        const isFoundationProgramSelected = (programId: number): boolean => {
            let programs = values.foundationPrograms;
            if (programs.filter(i => i.programId === programId).length > 0) {
                return true;
            }
            return false;
        }
        const isFoundationProgramClassSelected = (programId: number, classId: number): boolean => {
            let programs = values.foundationPrograms;
            let program = programs.find(i => i.programId === programId);
            if (program !== undefined) {
                if (program.classList.find(i => i.classId === classId) !== undefined) {
                    return true;
                }
            }
            return false;
        }
        const isVideoLessionProgramSelected = (filterId: number): boolean => {
            let programs = values.videoLessionPrograms;
            if (programs && programs.filter(i => i.filterId === filterId).length > 0) {
                return true;
            }
            return false;
        }


        const getFoundationProgram = (programId: number) => {
            return FoundationProgramConstants.find(i => i.programId == programId);
        }
        const getClassInformation = (classId: number) => {
            return ClassListConstants.find(i => i.classId === classId);
        }
        const handleFoundationProgramSelected = (programId: number, isChecked: boolean) => {
            let data = values.foundationPrograms;
            if (isChecked) {
                var program = getFoundationProgram(programId);
                if (program !== undefined)
                    data.push(program);
            } else {
                data = data.filter(i => i.programId !== programId);
            }
            setFieldValue('foundationPrograms', data);
        }
        const handleFoundationProgramClassSelected = (programId: number, classId: number, isChecked: boolean) => {
            let data = values.foundationPrograms;
            if (isChecked) {
                var program = data.find(i => i.programId === programId);
                if (program === undefined) {
                    program = getFoundationProgram(programId) as IFoundationProgram;
                    program.classList = [];
                }
                let classData = getClassInformation(classId) as IProgramClass;
                program.classList.push(classData);
                data = data.filter(i => i.programId !== programId);
                data.push(program);
            } else {
                var program = data.find(i => i.programId === programId);
                if (program !== undefined) {
                    if (program.classList.length <= 1) {
                        data = data.filter(i => i.programId !== programId);
                    } else {
                        let classList = program.classList;
                        classList = classList.filter(i => i.classId !== classId);
                        program.classList = classList;
                        data = data.filter(i => i.programId !== programId);
                        data.push(program);
                    }
                }
            }
            setFieldValue('foundationPrograms', data);
        }
        const handleVideoLessionProgramSelected = (filterId: number, isChecked: boolean) => {
            let data = values.videoLessionPrograms;
            if (data === undefined)
                data = [];
            if (isChecked) {
                var program = VideoLessionPrograms.find(i => i.filterId === filterId);
                if (program !== undefined)
                    data.push(program);
            } else {
                data = data.filter(i => i.filterId !== filterId);
            }
            setFieldValue('videoLessionPrograms', data);
        }


        return (
            <Box component="form" noValidate>
                <Box sx={{ px: 3, pt: 2.5, pb: 1.5, display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ flexGrow: 1 }}>
                        {pageTitle && <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>{pageTitle}</Typography>}
                        {pageSubtitle && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{pageSubtitle}</Typography>}
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <Button variant="outlined" color="inherit" size="large" sx={{ minWidth: 100 }} onClick={handleCancelClick}>
                            Cancel
                        </Button>
                        <LoadingButton variant="contained" size="large" sx={{ px: 4, fontWeight: 600, minWidth: 120 }} onClick={handleSaveClick} loading={saving}>
                            Save
                        </LoadingButton>
                    </Box>
                </Box>
                <Divider />
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, bgcolor: 'grey.50' }}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            aria-label="school form tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                            sx={{
                                minHeight: 48,
                                '& .MuiTab-root': {
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    fontSize: '0.875rem',
                                    minHeight: 48,
                                    px: 2.5,
                                    color: 'text.secondary',
                                    '&.Mui-selected': {
                                        fontWeight: 700,
                                        color: 'primary.main',
                                    },
                                },
                                '& .MuiTabs-indicator': {
                                    height: 3,
                                    borderRadius: '3px 3px 0 0',
                                },
                            }}
                        >
                            <Tab label="Basic Info" {...a11yProps(0)} />
                            <Tab label="Contact Information" {...a11yProps(1)} />
                            <Tab label="Foundation Programs" {...a11yProps(2)} />
                            <Tab label="Olympiad Exams" {...a11yProps(3)} />
                            <Tab label="Special Access" {...a11yProps(4)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={tabValue} index={0}>
                        <Box sx={{ p: 3 }}>
                            <Grid container spacing={2}>
                                {/* School Identity */}
                                <Grid item xs={12} md={8}>
                                    <Card variant="outlined" sx={{ p: 2.5, height: '100%' }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: 'text.secondary', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.06em' }}>School Identity</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="txtSchoolName"
                                                    label={controlState.schoolName.label.schoolName}
                                                    disabled={controlState.schoolName.disable.schoolName}
                                                    onBlur={handleBlur}
                                                    value={values.schoolName}
                                                    onChange={handleChange}
                                                    name="schoolName"
                                                    error={!!errors.schoolName}
                                                    helperText={errors.schoolName}
                                                    fullWidth
                                                    autoFocus
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    id="txtMobileNumber"
                                                    label={controlState.mobileNumber.label.mobileNumber}
                                                    disabled={controlState.mobileNumber.disable.mobileNumber}
                                                    onBlur={handleBlur}
                                                    value={values.mobileNumber}
                                                    onChange={handleChange}
                                                    name="mobileNumber"
                                                    error={!!errors.mobileNumber}
                                                    helperText={errors.mobileNumber}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    id="txtSchoolEmail"
                                                    label={controlState.email.label.email}
                                                    disabled={controlState.email.disable.email}
                                                    onBlur={handleBlur}
                                                    value={values.email}
                                                    onChange={handleChange}
                                                    name="email"
                                                    error={!!errors.email}
                                                    helperText={errors.email}
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                {/* Credentials */}
                                <Grid item xs={12} md={4}>
                                    <Card variant="outlined" sx={{ p: 2.5, height: '100%' }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: 'text.secondary', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.06em' }}>Login Credentials</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="txtUserName"
                                                    label={controlState.userName.label.userName}
                                                    disabled={controlState.userName.disable.userName}
                                                    onBlur={handleBlur}
                                                    value={values.userName}
                                                    onChange={handleChange}
                                                    name="userName"
                                                    error={!!errors.userName}
                                                    helperText={errors.userName}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="txtPassword"
                                                    label={controlState.password.label.password}
                                                    disabled={controlState.password.disable.password}
                                                    onBlur={handleBlur}
                                                    value={values.password}
                                                    onChange={handleChange}
                                                    name="password"
                                                    error={!!errors.password}
                                                    helperText={errors.password}
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                {/* Location */}
                                <Grid item xs={12}>
                                    <Card variant="outlined" sx={{ p: 2.5 }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: 'text.secondary', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.06em' }}>Location</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4} md={3}>
                                                <FormControl fullWidth error={!!errors.state}>
                                                    <InputLabel id="state-select-label">State</InputLabel>
                                                    <Select
                                                        labelId="state-select-label"
                                                        id="state-select"
                                                        value={values.state}
                                                        label={controlState.state.label.state}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        name="state"
                                                    >
                                                        <MenuItem value={'AP'}>Andhra Pradesh</MenuItem>
                                                        <MenuItem value={'TG'}>Telangana</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="txtAddress"
                                                    label={controlState.address.label.address}
                                                    disabled={controlState.address.disable.address}
                                                    onBlur={handleBlur}
                                                    value={values.address}
                                                    onChange={handleChange}
                                                    name="address"
                                                    error={!!errors.address}
                                                    helperText={errors.address}
                                                    fullWidth
                                                    multiline
                                                    rows={3}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={1}>
                        <Box sx={{ p: 3 }}>
                            <Grid container spacing={3}>
                                {/* Chairman */}
                                <Grid item xs={12} md={4}>
                                    <Card variant="outlined" sx={{ p: 2.5, height: '100%' }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: 'text.secondary', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.06em' }}>Chairman</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label={controlState.chairmanName.label.chairmanName}
                                                    disabled={controlState.chairmanName.disable.chairmanName}
                                                    onBlur={handleBlur}
                                                    value={values.chairmanName}
                                                    onChange={handleChange}
                                                    name="chairmanName"
                                                    error={!!errors.chairmanName}
                                                    helperText={errors.chairmanName}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label={controlState.chairmanWhatsAppContact.label.chairmanWhatsAppContact}
                                                    disabled={controlState.chairmanWhatsAppContact.disable.chairmanWhatsAppContact}
                                                    onBlur={handleBlur}
                                                    value={values.chairmanWhatsAppContact}
                                                    onChange={handleChange}
                                                    name="chairmanWhatsAppContact"
                                                    error={!!errors.chairmanWhatsAppContact}
                                                    helperText={errors.chairmanWhatsAppContact}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                {/* Principal */}
                                <Grid item xs={12} md={4}>
                                    <Card variant="outlined" sx={{ p: 2.5, height: '100%' }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: 'text.secondary', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.06em' }}>Principal</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label={controlState.principalName.label.principalName}
                                                    disabled={controlState.principalName.disable.principalName}
                                                    onBlur={handleBlur}
                                                    value={values.principalName}
                                                    onChange={handleChange}
                                                    name="principalName"
                                                    error={!!errors.principalName}
                                                    helperText={errors.principalName}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label={controlState.principalWhatsAppContact.label.principalWhatsAppContact}
                                                    disabled={controlState.principalWhatsAppContact.disable.principalWhatsAppContact}
                                                    onBlur={handleBlur}
                                                    value={values.principalWhatsAppContact}
                                                    onChange={handleChange}
                                                    name="principalWhatsAppContact"
                                                    error={!!errors.principalWhatsAppContact}
                                                    helperText={errors.principalWhatsAppContact}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                {/* Program Incharge */}
                                <Grid item xs={12} md={4}>
                                    <Card variant="outlined" sx={{ p: 2.5, height: '100%' }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: 'text.secondary', textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.06em' }}>Program Incharge</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label={controlState.programInChargeName.label.programInChargeName}
                                                    disabled={controlState.programInChargeName.disable.programInChargeName}
                                                    onBlur={handleBlur}
                                                    value={values.programInChargeName}
                                                    onChange={handleChange}
                                                    name="programInChargeName"
                                                    error={!!errors.programInChargeName}
                                                    helperText={errors.programInChargeName}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label={controlState.programInchargeWhatsAppContact.label.programInchargeWhatsAppContact}
                                                    disabled={controlState.programInchargeWhatsAppContact.disable.programInchargeWhatsAppContact}
                                                    onBlur={handleBlur}
                                                    value={values.programInchargeWhatsAppContact}
                                                    onChange={handleChange}
                                                    name="programInchargeWhatsAppContact"
                                                    error={!!errors.programInchargeWhatsAppContact}
                                                    helperText={errors.programInchargeWhatsAppContact}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={2}>
                        <Box sx={{ p: 3 }}>
                            <Grid container spacing={2}>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Card variant="outlined" sx={{ height: '100%' }}>
                                        <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                            <FormControlLabel
                                                label={<Typography fontWeight={600} fontSize="0.9rem">{getFoundationProgram(1)?.programName}</Typography>}
                                                control={<Checkbox checked={isFoundationProgramSelected(1)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramSelected(1, event.target.checked)} />}
                                            />
                                        </Box>
                                        <Divider />
                                        <Box sx={{ px: 2, py: 1, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel label="6th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(1, 6)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(1, 6, event.target.checked)} />} />
                                            <FormControlLabel label="7th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(1, 7)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(1, 7, event.target.checked)} />} />
                                            <FormControlLabel label="8th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(1, 8)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(1, 8, event.target.checked)} />} />
                                            <FormControlLabel label="9th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(1, 9)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(1, 9, event.target.checked)} />} />
                                            <FormControlLabel label="10th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(1, 10)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(1, 10, event.target.checked)} />} />

                                        </Box>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Card variant="outlined" sx={{ height: '100%' }}>
                                        <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                            <FormControlLabel
                                                label={<Typography fontWeight={600} fontSize="0.9rem">{FoundationProgramData.TechnoOlympiadProgram.programName}</Typography>}
                                                control={<Checkbox checked={isFoundationProgramSelected(FoundationProgramData.TechnoOlympiadProgram.programId)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramSelected(FoundationProgramData.TechnoOlympiadProgram.programId, event.target.checked)} />}
                                            />
                                        </Box>
                                        <Divider />
                                        <Box sx={{ px: 2, py: 1, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel label="6th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 6)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 6, event.target.checked)} />} />
                                            <FormControlLabel label="7th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 7)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 7, event.target.checked)} />} />
                                            <FormControlLabel label="8th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 8)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 8, event.target.checked)} />} />
                                            <FormControlLabel label="9th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 9)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 9, event.target.checked)} />} />
                                            <FormControlLabel label="10th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 10)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.TechnoOlympiadProgram.programId, 10, event.target.checked)} />} />
                                        </Box>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Card variant="outlined" sx={{ height: '100%' }}>
                                        <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                            <FormControlLabel
                                                label={<Typography fontWeight={600} fontSize="0.9rem">Global Olympiad</Typography>}
                                                control={<Checkbox checked={isFoundationProgramSelected(FoundationProgramData.GlobalOlympiadProgram.programId)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramSelected(FoundationProgramData.GlobalOlympiadProgram.programId, event.target.checked)} />}
                                            />
                                        </Box>
                                        <Divider />
                                        <Box sx={{ px: 2, py: 1, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel label="1st Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 1)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 1, event.target.checked)} />} />
                                            <FormControlLabel label="2nd Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 2)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 2, event.target.checked)} />} />
                                            <FormControlLabel label="3rd Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 3)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 3, event.target.checked)} />} />
                                            <FormControlLabel label="4th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 4)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 4, event.target.checked)} />} />
                                            <FormControlLabel label="5th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 5)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.GlobalOlympiadProgram.programId, 5, event.target.checked)} />} />
                                        </Box>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Card variant="outlined" sx={{ height: '100%' }}>
                                        <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                            <FormControlLabel
                                                label={<Typography fontWeight={600} fontSize="0.9rem">Fact Olympiad</Typography>}
                                                control={<Checkbox checked={isFoundationProgramSelected(FoundationProgramData.FACTProgram.programId)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramSelected(FoundationProgramData.FACTProgram.programId, event.target.checked)} />}
                                            />
                                        </Box>
                                        <Divider />
                                        <Box sx={{ px: 2, py: 1, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel label="6th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.FACTProgram.programId, 6)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.FACTProgram.programId, 6, event.target.checked)} />} />
                                            <FormControlLabel label="7th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.FACTProgram.programId, 7)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.FACTProgram.programId, 7, event.target.checked)} />} />
                                            <FormControlLabel label="8th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.FACTProgram.programId, 8)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.FACTProgram.programId, 8, event.target.checked)} />} />
                                            <FormControlLabel label="9th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.FACTProgram.programId, 9)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.FACTProgram.programId, 9, event.target.checked)} />} />

                                        </Box>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Card variant="outlined" sx={{ height: '100%' }}>
                                        <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                            <FormControlLabel
                                                label={<Typography fontWeight={600} fontSize="0.9rem">Medi Edge</Typography>}
                                                control={<Checkbox checked={isFoundationProgramSelected(FoundationProgramData.MediEdgeProgram.programId)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramSelected(FoundationProgramData.MediEdgeProgram.programId, event.target.checked)} />}
                                            />
                                        </Box>
                                        <Divider />
                                        <Box sx={{ px: 2, py: 1, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel label="6th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 6)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 6, event.target.checked)} />} />
                                            <FormControlLabel label="7th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 7)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 7, event.target.checked)} />} />
                                            <FormControlLabel label="8th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 8)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 8, event.target.checked)} />} />
                                            <FormControlLabel label="9th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 9)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 9, event.target.checked)} />} />
                                            <FormControlLabel label="10th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 10)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.MediEdgeProgram.programId, 10, event.target.checked)} />} />
                                        </Box>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Card variant="outlined" sx={{ height: '100%' }}>
                                        <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                            <FormControlLabel
                                                label={<Typography fontWeight={600} fontSize="0.9rem">ASK Jr</Typography>}
                                                control={<Checkbox checked={isFoundationProgramSelected(FoundationProgramData.ASKJrProgram.programId)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramSelected(FoundationProgramData.ASKJrProgram.programId, event.target.checked)} />}
                                            />
                                        </Box>
                                        <Divider />
                                        <Box sx={{ px: 2, py: 1, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel label="1st Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 1)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 1, event.target.checked)} />} />
                                            <FormControlLabel label="2nd Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 2)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 2, event.target.checked)} />} />
                                            <FormControlLabel label="3rd Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 3)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 3, event.target.checked)} />} />
                                            <FormControlLabel label="4th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 4)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 4, event.target.checked)} />} />
                                            <FormControlLabel label="5th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 5)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.ASKJrProgram.programId, 5, event.target.checked)} />} />
                                        </Box>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Card variant="outlined" sx={{ height: '100%' }}>
                                        <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                            <FormControlLabel
                                                label={<Typography fontWeight={600} fontSize="0.9rem">ASK Sr</Typography>}
                                                control={<Checkbox checked={isFoundationProgramSelected(FoundationProgramData.ASKSrProgram.programId)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramSelected(FoundationProgramData.ASKSrProgram.programId, event.target.checked)} />}
                                            />
                                        </Box>
                                        <Divider />
                                        <Box sx={{ px: 2, py: 1, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel label="6th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.ASKSrProgram.programId, 6)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.ASKSrProgram.programId, 6, event.target.checked)} />} />
                                            <FormControlLabel label="7th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.ASKSrProgram.programId, 7)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.ASKSrProgram.programId, 7, event.target.checked)} />} />
                                            <FormControlLabel label="8th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.ASKSrProgram.programId, 8)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.ASKSrProgram.programId, 8, event.target.checked)} />} />
                                            <FormControlLabel label="9th Class" control={<Checkbox size="small" checked={isFoundationProgramClassSelected(FoundationProgramData.ASKSrProgram.programId, 9)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFoundationProgramClassSelected(FoundationProgramData.ASKSrProgram.programId, 9, event.target.checked)} />} />
                                        </Box>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={3}>
                        <Box sx={{ p: 3 }}>
                            <Grid container spacing={1.5}>
                                {[
                                    { data: OlympiadExamData.CBAT, label: 'C-BAT' },
                                    { data: OlympiadExamData.AMAT, label: 'A-MAT' },
                                    { data: OlympiadExamData.RMM, label: 'R-MM' },
                                    { data: OlympiadExamData.RSM, label: 'R-SM' },
                                    { data: OlympiadExamData.TEAT, label: 'T-EAT' },
                                    { data: OlympiadExamData.BMAT, label: 'B-MAT' },
                                    { data: OlympiadExamData.KCCM, label: 'K.C.C.M' },
                                    { data: OlympiadExamData.JSC, label: 'JSC' },
                                    { data: OlympiadExamData.KSAT, label: 'K-SAT' },
                                    { data: OlympiadExamData.BVVS, label: 'B.V.V.S' },
                                    { data: OlympiadExamData.APPUSMA, label: 'APPUSMA' },
                                    { data: OlympiadExamData.TRSMA, label: 'TRSMA' },
                                    { data: OlympiadExamData.PSPA, label: 'PSPA' },
                                ].map(({ data, label }) => (
                                    <Grid item xs={6} sm={4} md={3} key={data.examId}>
                                        <Card variant="outlined" sx={{
                                            borderColor: isOlympiadExamSelected(data.examId) ? 'primary.main' : 'divider',
                                            bgcolor: isOlympiadExamSelected(data.examId) ? 'rgba(25,118,210,0.06)' : 'background.paper',
                                            transition: 'border-color 0.15s ease, background-color 0.15s ease',
                                        }}>
                                            <FormControlLabel
                                                control={<Checkbox checked={isOlympiadExamSelected(data.examId)} onChange={handleOlympiadExamChange} name={data.examName} value={data.examId} />}
                                                label={<Typography sx={{ fontWeight: isOlympiadExamSelected(data.examId) ? 600 : 400, fontSize: '0.9rem' }}>{label}</Typography>}
                                                sx={{ m: 0, px: 1.5, py: 1, width: '100%' }}
                                            />
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={4}>
                        <Box sx={{ p: 3 }}>
                            <Grid container spacing={2}>
                                {/* Video Lesson Programs */}
                                <Grid item xs={12} sm={6} md={3}>
                                    <Card variant="outlined" sx={{ height: '100%' }}>
                                        <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                            <Typography fontWeight={600} fontSize="0.9rem">Video Lesson Programs</Typography>
                                        </Box>
                                        <Divider />
                                        <Box sx={{ px: 2, py: 1, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel
                                                label="1st – 5th Class"
                                                control={<Checkbox size="small" checked={isVideoLessionProgramSelected(1)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleVideoLessionProgramSelected(1, event.target.checked)} />}
                                            />
                                            <FormControlLabel
                                                label="6th – 10th Class"
                                                control={<Checkbox size="small" checked={isVideoLessionProgramSelected(2)} onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleVideoLessionProgramSelected(2, event.target.checked)} />}
                                            />
                                        </Box>
                                    </Card>
                                </Grid>
                                {/* Magazine */}
                                <Grid item xs={12} sm={6} md={3}>
                                    <Card variant="outlined" sx={{ height: '100%' }}>
                                        <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                            <Typography fontWeight={600} fontSize="0.9rem">Magazine</Typography>
                                        </Box>
                                        <Divider />
                                        <Box sx={{ px: 2, py: 1, display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel
                                                label="Abhyasa Bharathi"
                                                control={<Checkbox size="small" checked={values.abhyasaBharathiMagazineAccess} onChange={handleAbhyasaBharathiAccessChange} name="abhyasaBharathiMagazineAccess" />}
                                            />
                                        </Box>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    </CustomTabPanel>
                </Box>
            </Box>
        );

    }
